export enum ClassType {
  Light = 'light',
  Regular = 'regular',
  Heavy = 'heavy'
}